import React from 'react';
import './letsTalk.scss';
import { Form } from 'react-bootstrap';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { SectionWrapper } from '../../theme/layouts/MainLayout';
import { techBlack } from '../../common/utils/constant';
import { useNavigate } from 'react-router-dom'
import { callApi, getUrlencoded, roles } from '../../common/utils/salesforce';
import { useAppContext } from '../../common/context';
import FormFields from '../../common/components/formFields';

const initValue = {
  Message__c: '',
  Role__c: '',
  first_name: '',
  last_name: '',
  // brand: '',
  Brand_Account__C: '',
  email: ''
}
function LetsTalkPage() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  // const [message, setMessage] = useState(null);
  const [values, setValue] = useState(initValue);
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [selectValue, setSelectValue] = useState(false)
  const { environment } = useAppContext();

  const onChange = e => {
    const { name, value } = e.target;
    const inputRegex = /^\s*$/;  
   
  
    if (e.target.tagName === 'SELECT') {
      setSelectValue(true)
    }
    if (name === 'email') {
      const newEmail = e.target.value;
      setEmail(newEmail);

      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      setIsValid(emailRegex.test(newEmail));
    }

    if(name === 'first_name' || name === 'last_name' || name === 'Brand_Account__C' || name === 'Message__c'){
      if(!inputRegex.test(value)){
        setValue({ ...values, [name]: value });
      } else{
        setValue({ ...values, [name]: '' });
      }
    } else {
      setValue({ ...values, [name]: value });
    }

  }

  const handleEmailClick = () => {
    window.location.href = 'mailto:info.ads@bestbuy.com';
  };

  const submitHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    setError(null);
    setValidated(true);
    try {
    if (form.checkValidity() && isValid) {
      for (let key in values) {
        if (values.hasOwnProperty(key)) {
          values[key] = values[key].trim();
        }
      }
      
      console.log("values**********", values);
      const urlencoded = getUrlencoded(values);
      callApi(urlencoded, environment)
        .then(response => {
          
          if (response) {
            setError(null);
            setValidated(false);
            navigate("/thank-you", { state: { message: "A member of our team will be in touch with you.", flag: false } })
          }
          return response;
        })

        .catch(error => {
          console.error('Submission failed:', error);
          setError('There was an issue with the submission. Please try again later.'); 
        });
    } else {
      setError('One or more fields have an error. Please check and try again.');
    }
  } catch (error) {
    console.error('Unexpected error during form submission:', error);
    setError('An unexpected error occurred. Please try again later.'); 
  }
  }
  return (
    <div className='letsTalk-wrapper-page'>
      <SectionWrapper bg={techBlack}>
        <section className=''>
          <div className='title-section-1'>Connect with a Best Buy Ads retail media expert today.</div>
        </section>
      </SectionWrapper>
      <SectionWrapper >
        <section className='midSection'>
          <Row>
            <Col md={7} sm={12}>
              <div className='form-section'>
                <Form method='POST' id="leadForm2" className='letsTalk-wrapper-page-section-style' noValidate validated={validated}
                  onSubmit={submitHandler}
                >
                  <FormFields
                    name="first_name"
                    label="First Name"
                    type="text"
                    value={values.first_name}
                    onChange={onChange}
                    placeholder="First Name"
                    required
                    isValid={isValid}
                    maxLength={25}
                    errorMessage="Please fill out this field."
                  />
                  <FormFields
                    name="last_name"
                    label="Last Name"
                    type="text"
                    value={values.last_name}
                    onChange={onChange}
                    placeholder="Last Name"
                    required
                    isValid={isValid}
                    maxLength={40}
                    errorMessage="Please fill out this field."
                  />
                  <FormFields
                    name="Brand_Account__C"
                    label="Brand"
                    type="text"
                    value={values.Brand_Account__C}
                    onChange={onChange}
                    placeholder="Brand"
                    required
                    isValid={isValid}
                    maxLength={50}
                    errorMessage="Please fill out this field."
                  />
                  <FormFields
                    name="email"
                    label="Business Email"
                    type="email"
                    value={values.email}
                    onChange={onChange}
                    placeholder="Business Email"
                    required
                    isValid={isValid}
                    maxLength={100}
                    isInvalid={!isValid && email.length > 0}
                    errorMessage="Please enter a valid email address"
                  />
                  <FormFields
                    name="Role__c"
                    label="Role"
                    type="select"
                    value={values.Role__c}
                    onChange={onChange}
                    options={roles}
                    required
                    isValid={isValid}
                    validated={validated}
                    selectValue={selectValue}
                    errorMessage="Please select a role."
                  />
                  <FormFields
                    name="Message__c"
                    label="How can we support your advertising goals?"
                    type="textarea"
                    value={values.Message__c}
                    onChange={onChange}
                    placeholder=""
                    required
                    rows={5}
                    isValid={isValid}
                    maxLength={250}
                    errorMessage="Please fill out this field."
                  />
                  <div className={error ? 'submit-block' : 'mt-3 mb-75'}>
                    <Button className='submitBtn' variant="outline-*" type='submit' id="btnSubmit2">Submit</Button>
                  </div>
                  {error && (
                    <div className='container form-error-container'>
                      {error && <div className="article-error-msg">{error}</div>}
                      {/* {message && <div className="article-success">{message}</div>} */}
                    </div>
                  )}
                </Form>
              </div>

            </Col>
            <Col md={5} sm={12}>
              <div className="right-section">
                <div className='right-section-first-element'>
                  Prefer to email us?
                  <Button className='emailBtn mt-4 ms-0' variant="outline-*" onClick={handleEmailClick}>Send an email</Button>
                </div>
                <div className='right-section-second-element'>
                  <div className='mb-4'>
                    <h3 className='letsTalk-h3'>Careers</h3>
                    <a href="https://www.jobs.bestbuy.com/bby">jobs.bestbuy.com</a>
                  </div>
                  <div className='mb-4'>
                    <h3 className='letsTalk-h3'>Press Inquiry</h3>
                    <a href='mailto:info.ads@bestbuy.com'>info@bestbuy.com</a>
                  </div>
                  <div className='mb-4'>
                    <h3 className='letsTalk-h3'>Need support?</h3>
                    <a href="https://www.bestbuy.com/support">bestbuy.com/support</a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </section>
      </SectionWrapper>
    </div>
  )
}

export default LetsTalkPage;